import script from "./RoomManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomManagement.vue?vue&type=script&setup=true&lang=js"

import "./RoomManagement.vue?vue&type=style&index=0&id=f15f66ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f15f66ea"]])

export default __exports__